const apiKey = '---';
const apiBaseUrl = 'https://api.zoomos.by'; // https

module.exports = {
  apiKey,
  apiBaseUrl
};